module.exports = "/cyber/_next/static/images/mtsBalance-d3f32a6ebee3804d50315e1300e2a360.png";